import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';

class ItemCancelledFeedbackModal extends React.Component {
  render() {
    const { isOpen, toggle, justification, title } = this.props;

    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <p className="pt-3">
            <strong>{justification}</strong>
          </p>
        </ModalBody>
        <ModalFooter>
          <button className="btn primary-button" onClick={toggle}>
            OK
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}

ItemCancelledFeedbackModal.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  validTitle: PropTypes.string,
  invalidTitle: PropTypes.string,
  valid: PropTypes.arrayOf(PropTypes.number),
  invalid: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.number,
      errors: PropTypes.arrayOf(PropTypes.string)
    })
  )
};

ItemCancelledFeedbackModal.defaultProps = {
  isOpen: false,
  title: '',
  validTitle: '',
  invalidTitle: '',
  valid: [],
  invalid: []
};

export default ItemCancelledFeedbackModal;
